import React, { Component } from 'react';
import { connect } from "react-redux";
import { ConfirmationView } from "../subcomponents"
import { newLoanActions } from "../../_actions";

class Confirmation extends Component {
    static displayName = Confirmation.name;

    constructor(props) {
        super(props);
        this.state = { isToggle: false, branchDetails: "" };
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleClick(e) {
        this.setState({ isToggle: !this.state.isToggle });
    }

    handleSubmit() {
        
        const { dispatch } = this.props;

        dispatch(newLoanActions.confirmation());
    }


    render() {
        return (
            <ConfirmationView sunLoanBranchId={this.props.BranchId} onDone={this.handleSubmit}/>
        );
    }
}


function mapStateToProps(state) {
    const { error, errorString, BranchId } = state.newLoan;
    return {
        error, errorString, BranchId
    };
}

const connectedConfirmation= connect(mapStateToProps)(Confirmation);
export { connectedConfirmation as Confirmation };


// WEBPACK FOOTER //
// ./src/components/subcomponents/Confirmation.js